import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-rollback-detail-dialog',
  templateUrl: './rollback-detail-dialog.component.html',
  styleUrls: ['./rollback-detail-dialog.component.scss']
})
export class RollbackDetailDialogComponent {
  entityId: string;
  entityName: string;
  changedBy: string;
  timestamp: string;
  environment: string;
  serviceName: string;
  operation: string;
  beforeStateJson: string;
  afterStateJson: string;
  hasChanges: boolean;

  constructor(
    public dialogRef: MatDialogRef<RollbackDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const item = data.item || {};
    const changes: any[] = Array.isArray(item.genesysPropertyChanges)
      ? item.genesysPropertyChanges
      : [];

    this.entityId = item.entityId || '-';
    this.entityName = item.entityName || '-';
    this.changedBy = item.user || '-';
    this.timestamp = this.formatDate(item.date);
    this.environment = data.organizationId || item.organisationName || '-';
    this.serviceName = item.serviceName || '-';
    this.operation = item.operation || '-';
    this.hasChanges = changes.length > 0;

    const before: any = {};
    const after: any = {};
    const nullLike = (v: any) => v === null || v === undefined || v === 'null';
    changes.forEach((c: any) => {
      if (c.property !== undefined) {
        before[c.property] = nullLike(c.oldValues) ? '' : c.oldValues;
        after[c.property]  = nullLike(c.newValues) ? '' : c.newValues;
      }
    });

    this.beforeStateJson = this.hasChanges
      ? JSON.stringify(before, null, 2)
      : 'No property changes recorded.';
    this.afterStateJson = this.hasChanges
      ? JSON.stringify(after, null, 2)
      : 'No property changes recorded.';
  }

  formatDate(dateValue: any): string {
    if (!dateValue) return '-';
    try {
      const raw = `${dateValue}`;
      const date = new Date(raw.includes('UTC') ? raw : `${raw} UTC`);
      if (isNaN(date.getTime())) return raw;
      return date.toLocaleString('en-GB', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
    } catch (_) {
      return `${dateValue}`;
    }
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
